var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "a-row",
        { attrs: { gutter: [16, 48], type: "flex" } },
        [
          _c("a-col", { attrs: { span: 24 } }, [
            _c(
              "fieldset",
              [
                _c("legend", [
                  _vm._v(" " + _vm._s(_vm.$t("lbl_basic_feature")) + " ")
                ]),
                _c(
                  "a-row",
                  { attrs: { gutter: [16, 16], type: "flex" } },
                  [
                    _c("a-col", { attrs: { span: 6 } }, [
                      _c("p", [
                        _vm._v(" " + _vm._s(_vm.$t("lbl_costing_method")) + " ")
                      ])
                    ]),
                    _c(
                      "a-col",
                      { attrs: { span: 6 } },
                      [
                        _c("a-select", {
                          staticClass: "w-100",
                          attrs: {
                            options: _vm.costMethodOptions,
                            loading: _vm.loading.costMethod,
                            "data-testid": "inventory-cost-method",
                            "label-in-value": ""
                          },
                          model: {
                            value: _vm.state.field.inventory.costMethod.value,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.state.field.inventory.costMethod,
                                "value",
                                $$v
                              )
                            },
                            expression: "state.field.inventory.costMethod.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "a-row",
                  { attrs: { gutter: [16, 16], type: "flex" } },
                  [
                    _c("a-col", { attrs: { span: 6 } }, [
                      _c("p", [
                        _vm._v(
                          " " + _vm._s(_vm.$t("lbl_show_product_stock")) + " "
                        )
                      ])
                    ]),
                    _c(
                      "a-col",
                      { attrs: { span: 6 } },
                      [
                        _c("a-select", {
                          staticClass: "w-100",
                          attrs: {
                            options: _vm.booleanOptions,
                            "data-testid": "inventory-show-stock"
                          },
                          model: {
                            value: _vm.state.field.inventory.showStock.value,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.state.field.inventory.showStock,
                                "value",
                                $$v
                              )
                            },
                            expression: "state.field.inventory.showStock.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "a-row",
                  { attrs: { gutter: [16, 16], type: "flex" } },
                  [
                    _c("a-col", { attrs: { span: 6 } }, [
                      _c("p", [
                        _vm._v(
                          " " + _vm._s(_vm.$t("lbl_multi_warehouse")) + " "
                        )
                      ])
                    ]),
                    _c(
                      "a-col",
                      { attrs: { span: 6 } },
                      [
                        _c("a-select", {
                          staticClass: "w-100",
                          attrs: {
                            "data-testid": "inventory-multi-warehouse",
                            options: _vm.booleanOptions
                          },
                          model: {
                            value:
                              _vm.state.field.inventory.multiWarehouse.value,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.state.field.inventory.multiWarehouse,
                                "value",
                                $$v
                              )
                            },
                            expression:
                              "state.field.inventory.multiWarehouse.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "a-row",
                  { attrs: { gutter: [16, 16], type: "flex" } },
                  [
                    _c("a-col", { attrs: { span: 6 } }, [
                      _c("p", [
                        _vm._v(" " + _vm._s(_vm.$t("lbl_multi_uom")) + " ")
                      ])
                    ]),
                    _c(
                      "a-col",
                      { attrs: { span: 6 } },
                      [
                        _c("a-select", {
                          staticClass: "w-100",
                          attrs: {
                            "data-testid": "inventory-multi-uom",
                            options: _vm.booleanOptions
                          },
                          model: {
                            value: _vm.state.field.inventory.multiUom.value,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.state.field.inventory.multiUom,
                                "value",
                                $$v
                              )
                            },
                            expression: "state.field.inventory.multiUom.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "a-row",
                  { attrs: { gutter: [16, 16], type: "flex" } },
                  [
                    _c("a-col", { attrs: { span: 6 } }, [
                      _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("lbl_serial_number_product")) +
                            " "
                        )
                      ])
                    ]),
                    _c(
                      "a-col",
                      { attrs: { span: 6 } },
                      [
                        _c("a-select", {
                          staticClass: "w-100",
                          attrs: {
                            "data-testid": "inventory-serial-number-product",
                            options: _vm.booleanOptions
                          },
                          model: {
                            value: _vm.state.field.inventory.sNProduct.value,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.state.field.inventory.sNProduct,
                                "value",
                                $$v
                              )
                            },
                            expression: "state.field.inventory.sNProduct.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "a-row",
        { staticClass: "mt-3", attrs: { gutter: [16, 48], type: "flex" } },
        [
          _c(
            "a-col",
            { attrs: { span: 6 } },
            [
              _vm.$can("update", "preferences")
                ? _c(
                    "a-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.state.loadingSave,
                        "data-testid": "inventory-save"
                      },
                      on: { click: _vm.onSave }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("lbl_save")) + " ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }